import { useState } from "react";
import { Link } from "react-router-dom";
import { FaQuestionCircle } from "react-icons/fa";
import "./choice.css";

function Choice() {
  // Estados para mostrar/ocultar los tooltips
  const [showUserTooltip, setShowUserTooltip] = useState(false);
  const [showEmployerTooltip, setShowEmployerTooltip] = useState(false);

  return (
    <div className="choice-container">
      <div className="choice-card">
        <h1 className="choice-title">¿Cómo deseas ingresar?</h1>

        <div className="choice-button-group">

          {/* Opción de Usuario */}
          <div className="choice-option">
            <Link to="/login?role=user" className="btn btn-primary">
              Usuario: Busco Oportunidades
            </Link>

            {/* Ícono de interrogación para el usuario */}
            <div
              className="question-icon"
              onMouseEnter={() => setShowUserTooltip(true)}
              onMouseLeave={() => setShowUserTooltip(false)}
              // Si prefieres con click en vez de hover, usa onClick
              // onClick={() => setShowUserTooltip((prev) => !prev)}
            >
              <FaQuestionCircle />
            </div>

            {/* Tooltip del usuario */}
            {showUserTooltip && (
              <div className="tooltip-box">
                <p>
                  ¿Necesitas oportunidades de empleo, asesoría, educación, migración o
                  emprendimiento? Selecciona esta opción <br />
                  
                </p>
              </div>
            )}
          </div>

          {/* Opción de Empleador */}
          <div className="choice-option">
            <Link to="/login?role=employer" className="btn btn-secondary">
              Empleador: Busco Talento
            </Link>

            {/* Ícono de interrogación para el empleador */}
            <div
              className="question-icon"
              onMouseEnter={() => setShowEmployerTooltip(true)}
              onMouseLeave={() => setShowEmployerTooltip(false)}
            >
              <FaQuestionCircle />
            </div>

            {/* Tooltip del empleador */}
            {showEmployerTooltip && (
              <div className="tooltip-box">
                <p>
                  ¿Quieres publicar puestos de trabajo y encontrar candidatos? <br />
                  Selecciona esta opción.
                </p>
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
}

export default Choice;